import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { UploadStatus } from '../../components/upload-status/upload-status';
import { IconComponent, SkeletonComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { DatePipe, NgClass } from '@angular/common';

import { OnboardingTooltipType } from '../../types/onboarding-tooltip.type';
import { historyTutorial } from './upload-history.tutorial';
import { EmptyContentListElement } from '../../components/empty-content-list-element/empty-content-list-element';
import { ApiService } from '../../services/api.service';
import { HttpResourceRef } from '@angular/common/http';
import { UploadContentType } from '../../types/upload-content.type';
import { ColorService } from '../../services/color.service';


@Component({
  selector: 'app-upload-history',
  imports: [
    TranslateModule,
    UpperFirstLetterPipe,
    UploadStatus,
    IconComponent,
    NgClass,
    SkeletonComponent,
    EmptyContentListElement,
    DatePipe
    // TutorialTooltip,
    // Paginator
  ],
  templateUrl: './upload-history.html',
  styleUrl: './upload-history.scss',
  // hostDirectives: [TutorialOnboarding], // TODO => pour les test des tutorials
  // providers: [{ provide: TUTORIAL_DATA_TOKEN, useValue: signal(historyTutorial) }], // TODO => pour les test des tutorials
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadHistory {
  private apiService: ApiService = inject(ApiService);
  colorService: ColorService = inject(ColorService);
  historyTutorial: Signal<readonly OnboardingTooltipType[]> = computed(() => historyTutorial);
  uploadCount: Signal<number> = computed(() => this.uploads.value()?.length ?? 0);
  uploads: HttpResourceRef<UploadContentType[] | undefined> = this.apiService.getUploadHistoryRessources;

  ngOnInit(): void {
    this.uploads.reload()
  }
}
